import {
  FETCH_TWILIO_CONVERSATIONS,
  FETCH_TWILIO_CONVERSATIONS_SUCCESS,
  PUSH_TWILIO_CONVERSATION_SUCCESS,
  PUSH_TWILIO_CONVERSATION,
} from '../actions';

export const fetchTwilioConversationsRequest = () => ({
  type: FETCH_TWILIO_CONVERSATIONS,
});

export const pushTwilioConversations = (conversation) => ({
  type: PUSH_TWILIO_CONVERSATION,
  payload: conversation,
});

export const fetchTwilioConversationsSuccess = (conversations) => ({
  type: FETCH_TWILIO_CONVERSATIONS_SUCCESS,
  payload: conversations,
});

export const pushTwilioConversationsSuccess = (conversation) => ({
  type: PUSH_TWILIO_CONVERSATION_SUCCESS,
  payload: conversation,
});
